import { Button, FlexBox, Icon, IconNames, Text } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';

import styles from './featureCard.module.scss';

type FeatureCardProps = {
  readonly title: string;
  readonly description: string;
  readonly icon: IconNames;
  readonly learnMoreLink?: string;
  readonly onLearnMoreClick?: (url: string) => void;
};

export const FeatureCard = ({
  title,
  description,
  icon,
  learnMoreLink,
  onLearnMoreClick,
}: FeatureCardProps): JSX.Element => {
  const handleClick = useCallback(() => {
    if (!learnMoreLink) {
      return;
    }

    window.open(learnMoreLink, '_blank', 'noopener,noreferrer');
    onLearnMoreClick?.(learnMoreLink);
  }, [learnMoreLink, onLearnMoreClick]);

  return (
    <div className={styles.featureItem}>
      <Icon
        className={styles.featureIcon}
        name={icon}
        size={20}
        color="#5644D8"
      />
      <Text.Heading className={styles.featureTitle} variant="heading-3">
        {title}
      </Text.Heading>
      <Text.Paragraph className={styles.featureDescription}>
        {description}
      </Text.Paragraph>
      {learnMoreLink && (
        <FlexBox className={styles.featureAction}>
          <Button variant="secondary" onClick={handleClick}>
            Learn more
          </Button>
        </FlexBox>
      )}
    </div>
  );
};
